
import React, { useState } from "react";
import { verifyUser } from "../utils/api";

export default function SplashLogin({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
     const data = await verifyUser(email, password);

    if (data.ok) {
      // Store globally (no new dependencies)
      global.email = email;
      global.userId = data.user_id;
      global.companyId = data.company_id;
      global.placeholders = data.placeholders || {};

      onLoginSuccess({ email });
    } else {
      setError("Invalid credentials or no active subscription.");
    }

    } catch (err) {
      setError("Network error or server issue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 text-white">
      {/* Login Card */}
      <div className="bg-white text-[#0083b0] rounded-2xl p-8 w-full max-w-sm shadow-2xl text-center">
        <h2 className="text-2xl font-semibold mb-4">
          Welcome to the CQC Experts Assistant
        </h2>

        <p className="text-sm text-gray-500 mb-4">
          If you’re new here, just log in with your existing website username and password — 
          your account will be created automatically.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full border rounded-xl px-4 py-2 mb-3 text-black focus:outline-none focus:ring-2 focus:ring-[#0083b0]"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full border rounded-xl px-4 py-2 mb-3 text-black focus:outline-none focus:ring-2 focus:ring-[#0083b0]"
          />

          <button
            disabled={loading}
            type="submit"
            className="w-full bg-[#0083b0] hover:bg-[#006f8a] text-white font-semibold py-2 rounded-xl transition duration-200"
          >
            {loading ? "Checking..." : "Log In"}
          </button>
        </form>

        {error && <p className="text-red-600 mt-3 text-sm">{error}</p>}
      </div>
    </div>
  );
}
